import { Calculator, Cpu, FileText, Folder, Globe, Mail, Monitor, Search, Settings, Shield, Terminal, User } from 'lucide-react';
import React, { useState } from 'react';

const StartMenu = ({ onAppClick, onClose, systemSpecs }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const pinnedApps = [
    { id: 'chrome', name: 'Chrome', icon: Globe },
    { id: 'explorer', name: 'File Explorer', icon: Folder },
    { id: 'settings', name: 'Settings', icon: Settings },
    { id: 'outlook', name: 'Outlook', icon: Mail },
    { id: 'calculator', name: 'Calculator', icon: Calculator },
    { id: 'notepad', name: 'Notepad', icon: FileText },
    { id: 'securitycenter', name: 'Windows Security', icon: Shield },
    { id: 'controlpanel', name: 'Control Panel', icon: Settings },
    { id: 'devicemanager', name: 'Device Manager', icon: Monitor },
    { id: 'services', name: 'Services', icon: Settings },
    { id: 'regedit', name: 'Registry Editor', icon: Settings },
    { id: 'taskmgr', name: 'Task Manager', icon: Cpu },
    { id: 'cmd', name: 'Command Prompt', icon: Terminal }
  ];

  return (
    <div
      className="absolute bottom-12 left-0 w-96 bg-black/95 backdrop-blur-lg rounded-t-lg border border-white/20 text-white z-[10000]"
      onClick={(e) => e.stopPropagation()}
    >
      {/* User Profile */}
      <div className="p-4 border-b border-white/10">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-blue-500 rounded-full flex items-center justify-center">
            <User size={20} />
          </div>
          <div>
            <div className="font-medium">{systemSpecs.username}</div>
            <div className="text-xs text-white/60">{systemSpecs.computerName}</div>
          </div>
        </div>
      </div>

      {/* Search */}
      <div className="p-4 border-b border-white/10">
        <div className="relative">
          <Search size={16} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-white/60" />
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Type here to search"
            className="w-full pl-10 pr-4 py-2 bg-white/10 rounded text-sm focus:outline-none focus:bg-white/20"
          />
        </div>
      </div>

      {/* Pinned Apps */}
      <div className="p-4">
        <div className="text-sm text-white/80 mb-3">Pinned</div>
        <div className="grid grid-cols-6 gap-2">
          {pinnedApps.map(app => {
            const IconComponent = app.icon;
            return (
              <button
                key={app.id}
                onClick={() => onAppClick(app.id)}
                className="flex flex-col items-center p-2 rounded hover:bg-white/10 group"
              >
                <IconComponent size={24} className="mb-1 text-white/80 group-hover:text-white" />
                <span className="text-xs text-center leading-tight text-white/60 group-hover:text-white/80">
                  {app.name}
                </span>
              </button>
            );
          })}
        </div>
      </div>

      {/* Power Options */}
      <div className="p-4 border-t border-white/10 flex justify-end">
        <button
          onClick={onClose}
          className="w-8 h-8 rounded flex items-center justify-center hover:bg-white/10"
        >
          <Settings size={16} className="text-white/80" />
        </button>
      </div>
    </div>
  );
};

export default StartMenu;
